import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'arrayToString'
})
export class ArrayToStringPipe implements PipeTransform {

  transform(value: any[], project: string, separator?: string): string {     
    value = value || [];
    const s =  separator || ',';
    const r = value.map(v => {      
      if (project && !v[project]) {
        throw new Error(`Cannot found ${project} property on array's elements`);
      }
      
      if (typeof(v) == typeof({}))
        return v[project];
      else
        return v;

    }).join(`${s} `);

    return r;
  }

}
